import Splide from '@splidejs/splide';

export default {
  init() {
    if (document.getElementById('dates-slider')) {
      new Splide('#dates-slider', {
        pagination: false,
        fixedWidth: '448px',
        perMove: 2,
        gap: '2rem',
        keyboard: 'focused',
        breakpoints: { 500: { fixedWidth: '270px', focus: 'center', perMove: 1 } },
      }).mount();
    }
  },
};
